import { useState } from "react";
import { Button, Form, Input, message } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import media from "../../../media";
import { validateAndLoginThunk } from "../../../store/thunks/authThunk";
import { encryptCryptoData } from "../../../utils/Constants";
import CustomLoader from "../customLoader";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [focusedField, setFocusedField] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  /* =====================================
     LOGIN SUBMIT
  ===================================== */
  const onFinish = async (values) => {
    
    try {
      setLoading(true);
      
      const encryptedPayload = await encryptCryptoData({
        username: values.username.trim(),
        password: values.password,
      });
      
      await dispatch(
        validateAndLoginThunk({
          auth: encryptedPayload,
        }),
      ).unwrap();

      navigate("/dashboard", {
        replace: true,
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const renderFloatingInput = (name, label, type = "text", icon = null) => {
    const value = form.getFieldValue(name);

    return (
      <div
        className={`floating-input ${
          focusedField === name || value ? "active" : ""
        }`}
      >
        <label>{label}</label>

        <Form.Item
          name={name}
          rules={[{ required: true, message: `${label} is required` }]}
        >
          <Input
            type={type === "password" && showPassword ? "text" : type}
            prefix={icon}
            suffix={
              type === "password" ? (
                showPassword ? (
                  <EyeOutlined
                    onClick={() => setShowPassword(false)}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <EyeInvisibleOutlined
                    onClick={() => setShowPassword(true)}
                    style={{ cursor: "pointer" }}
                  />
                )
              ) : null
            }
            onFocus={() => setFocusedField(name)}
            onBlur={() => setFocusedField("")}
          />
        </Form.Item>
      </div>
    );
  };

  return (
    <>
      {loading && <CustomLoader showLoader={loading} />}
      <div className="loginWrap loginForm">
        <div className="loginWrapCol">
          <div className="loginContent">
            <img src={media.logo.svg} alt="logo" className="cmLogo" />
            <h2>Quality Control Center</h2>
            <p>Data-Driven Quality Assurance</p>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              className="loginFormField"
            >
              {renderFloatingInput(
                "username",
                "Username",
                "text",
                <UserOutlined />,
              )}

              {renderFloatingInput(
                "password",
                "Password",
                "password",
                <LockOutlined />,
              )}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="defaultBtn w-100"
                >
                  Sign in
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>

        <div className="loginWrapCol">
          <img src={media.loginMedia.jpg} alt="login" className="bgImage" />
          {/* <div class="centered">
          <h2>
            <span></span>
          </h2>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default Login;
